export const organizationStatusEnum = {
  ACTIVE: true,
  INACTIVE: false,
}

export const organizationStatus = {
  [organizationStatusEnum.ACTIVE]: 'Active',
  [organizationStatusEnum.INACTIVE]: 'Inactive',
}